import './libs/dropdown/dropdown.js'
import './libs/popup.js'
import './libs/popup-img.js'
import './libs/tooltip.js'
import './libs/collapse'
import './october/requests'

import IMask from 'imask';

/*кнопка меню-бургера*/
//открытие меню
// document.querySelector('.header__burger').addEventListener('click', function burgerOpen() {
//     document.querySelector('.menu-burger').style.display="block";
//     document.querySelector('body').classList.add('oc-hidden');
// })
// //закрытие меню
// function burgerMenuClose() {
//     document.querySelector('.menu-burger').style.display="none";
//     document.querySelector('body').classList.remove('oc-hidden');
// }
// document.querySelector('.menu-burger__close').addEventListener('click', function burgerCloseBtn() {
//     burgerMenuClose();
// })
// document.querySelector('.menu-burger').addEventListener('click', function burgerClose(event) {
//     if (event.target.closest('.menu-burger__content') ) {
//         // клик внутри элемента
//         return;
//     }
//     burgerMenuClose();
// })

let isBurgerOpen = false;
function closeBurger() {
    isBurgerOpen = false;
    document.querySelector('.new-menu-burger').classList.remove('new-menu-burger_open');
    document.querySelector('.new-header__burger').classList.remove('new-header__burger_open');
}

function openBurger() {
    isBurgerOpen = true;
    document.querySelector('.new-menu-burger').classList.add('new-menu-burger_open');
    document.querySelector('.new-header__burger').classList.add('new-header__burger_open');
}

document.body.addEventListener('click', (e) => {
    if (e.target.closest('.new-menu-burger')) {
        return
    }
    if (e.target.closest('.new-header__burger')) {
        isBurgerOpen ? closeBurger() : openBurger();
        return
    }
    closeBurger();
});

/*кнопка меню-бургера*/
/*маска номер телефона*/
document.querySelectorAll('[name="phone"]').forEach((el) => {
    let forceIgnoreMask = true;

    if (!el.classList.contains('ignore-imask') && !forceIgnoreMask ) {
        let mask = IMask(
            el,
            { mask: '+{7}(000)000-00-00'}
        );
    } else {
        let mask = IMask(
            el,
            { mask: /^[\d\s+\(\)\-\_]{0,25}$/ }
        );
    }
});
/*маска номер телефона*/
/*маска на инпут цифр*/
document.querySelectorAll('input.number').forEach((el) => {
    let mask = IMask(
        el,
        { mask: Number}
    );
});
/*маска на инпут цифр*/
